import { FirearmAssignmentService } from '../model/firearm-assignment.service';
import { CrudDataSource, HateoasMultipleResponseObject, PageSpecification } from '@scisys-uim/uim-common';
import { FirearmAssignment } from 'assets-model';
import { FirearmDocumentService } from '../../firearm/model/firearm-document.service';
import { Observable, throwError } from 'rxjs';
import { map } from 'rxjs/operators';


export class FirearmAssignmentDataSource extends CrudDataSource<FirearmAssignment> {

  constructor(private service: FirearmAssignmentService) {
    super();
  }

  protected callLoaderService(serviceArguments: any, pageSpec: PageSpecification): Observable<HateoasMultipleResponseObject<FirearmAssignment>> {
    return this.service.findByFullFilters(serviceArguments, pageSpec);
  }
}

export class FirearmAssignmentWithDocumentsDataSource extends CrudDataSource<FirearmAssignment> {

  constructor(private service: FirearmAssignmentService, private firearmDocumentService: FirearmDocumentService) {
    super();
  }

  protected callLoaderService(serviceArguments: any, pageSpec: PageSpecification): Observable<HateoasMultipleResponseObject<FirearmAssignment>> {
    return this.service.findByFullFilters(serviceArguments, pageSpec).pipe(map(response => {
      response.items.forEach(item => {
        this.firearmDocumentService.findFirearmDocuments(item.firearm.assetId, null).subscribe(
          documents => {
            documents.items.forEach(doc => {
              item.documents[doc.userAttributes?.firearmDocumentType] = item.documents[doc.userAttributes?.firearmDocumentType] || [];
              item.documents[doc.userAttributes?.firearmDocumentType].push(doc);
            });
          },
          error => {
            //if we're not allowed to view documents for a given firearmAssignment, we just ignore the error
            if (error.status !== 403) {
              throwError(error);
            }
          }
        );
      });
      return response;
    }));
  }

}


